import React from "react";
import NavBarItemTextLink from "../NavBarItemTextLink";
import createAbsolutePath from "createAbsolutePath";

const NavBarMessageLink = () => (
  <NavBarItemTextLink
    value="Messages"
    route={createAbsolutePath("/messages")}
  />
);

export default NavBarMessageLink;
